export default __webpack_public_path__ + "static/media/icon-food.bc5de397.svg";